const initialState = {
  data: null,
  loading: null,
  error: [null, null],
};

export default initialState;
